import { Trans, useTranslation } from 'react-i18next'

export interface PrivacyPolicyProps {
  translationNamespace?: string
  'data-testid': string
}

export default function PrivacyPolicy({
  translationNamespace = 'common',
  'data-testid': testId
}: Readonly<PrivacyPolicyProps>) {
  const { t } = useTranslation(translationNamespace)

  return (
    <p data-testid={testId}>
      <Trans
        t={t}
        i18nKey="privacy.privacy_text"
        components={{
          mail: (
            <a
              href={`mailto:${t('privacy.privacy_email_address')}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="link_label"
              data-testid={`${testId}-email-address`}
            >
              {t('privacy.privacy_email_address_label')}
            </a>
          )
        }}
      />
    </p>
  )
}
